// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2SBUo","content":"RecentSearches_content__3ePDx"};